import {
    get_pagamenti,
    get_pagamento,
    create_pagamento,
    update_pagamento,
    completa_pagamento,
    duplica_pagamento,
    elimina_pagamento,
} from "@/api/api.pagamento.js";

const pagamenti = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_CORRENTE: (state, p) => {
            state.corrente = p;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_pagamenti(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_pagamento(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati, filtri }) {
            const call = id ? update_pagamento(id, dati) : create_pagamento(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        completa({ dispatch }, { id, dati, filtri }) {
            return new Promise((resolve, reject) => {
                completa_pagamento(id, dati).then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, { id, filtri }) {
            return new Promise((resolve, reject) => {
                elimina_pagamento(id).then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, { id, filtri }) {
            return new Promise((resolve, reject) => {
                duplica_pagamento(id).then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
    },
};

export default pagamenti;
